/* eslint-disable react/prop-types */
import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Box from "@material-ui/core/Box";
import { Button, Grid, Typography, Chip, Divider } from "@material-ui/core";
import moment from "moment";

import { useStyles } from "Components/Modal/ModalStyles";
import { ReactComponent as CloseIcon } from "Assets/Svg/close.svg";

const InfoRow = ({ label, value }) => (
  <Grid container style={{ marginBottom: 10 }}>
    <Grid item xs={5} sm={4}>
      <Typography style={{ fontWeight: 600, fontSize: 14, color: "#555" }}>
        {label}
      </Typography>
    </Grid>
    <Grid item xs={7} sm={8}>
      <Typography style={{ fontSize: 14, wordBreak: "break-word" }}>
        {value === 0 || value ? value : "N/A"}
      </Typography>
    </Grid>
  </Grid>
);

const SubscriptionViewModal = ({ open, handleClose, subscription }) => {
  const classes = useStyles();
  const s = subscription || {};
  const features = Array.isArray(s.features) ? s.features : [];

  return (
    <Dialog
      open={open}
      aria-labelledby="subscription-view-title"
      maxWidth="sm"
      onClose={handleClose}
      PaperProps={{
        style: {
          borderRadius: 15,
          width: 520,
          maxWidth: "95vw",
          maxHeight: "85vh",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <DialogContent
        classes={{ root: classes.dialogContext }}
        style={{
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          minHeight: 0,
        }}
      >
        {/* Fixed header */}
        <div
          role="button"
          tabIndex={0}
          onKeyDown={handleClose}
          onClick={handleClose}
          className={classes.topBar}
          style={{ flexShrink: 0 }}
        >
          <span className={classes.title}>Subscription Details</span>
          <span className={`${classes.onHover} ${classes.closeBtn}`}>
            <CloseIcon />
          </span>
        </div>

        {/* Scrollable body */}
        <Box style={{ flex: 1, overflowY: "auto", minHeight: 0, padding: "20px 30px" }}>
          <Box style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
            <Typography variant="h6" style={{ fontWeight: 700 }}>
              {s.name || "Subscription"}
            </Typography>
            <Chip
              label={s.isActive ? "Active" : "Inactive"}
              size="small"
              style={{
                background: s.isActive ? "#e8f5e9" : "#ffebee",
                color: s.isActive ? "#2e7d32" : "#c62828",
                fontWeight: 600,
              }}
            />
          </Box>

          <InfoRow label="ID" value={s.id} />
          <InfoRow label="Name" value={s.name} />
          <InfoRow label="Slug" value={s.slug} />
          <InfoRow label="Price" value={s.price} />
          <InfoRow label="Duration" value={s.duration} />
          <InfoRow label="On Razorpay" value={s.isOnRazorpay ? "Yes" : "No"} />
          <InfoRow label="Stripe Product ID" value={s.stripeProductId} />
          <InfoRow label="Stripe Price ID" value={s.stripePriceId} />
          <InfoRow label="Status" value={s.isActive ? "Active" : "Inactive"} />
          <InfoRow
            label="Created At"
            value={s.createdAt ? moment(s.createdAt).format("DD/MM/YYYY HH:mm") : null}
          />
          <InfoRow
            label="Updated At"
            value={s.updatedAt ? moment(s.updatedAt).format("DD/MM/YYYY HH:mm") : null}
          />

          <Divider style={{ margin: "16px 0" }} />

          <Typography style={{ fontWeight: 600, fontSize: 14, color: "#555", marginBottom: 8 }}>
            Features ({features.length})
          </Typography>
          {features.length > 0 ? (
            <Box component="ul" style={{ margin: 0, paddingLeft: 20 }}>
              {features.map((f, i) => {
                const description =
                  typeof f === "string" ? f : f?.description;
                if (!description) return null;
                return (
                  <Typography
                    component="li"
                    // eslint-disable-next-line react/no-array-index-key
                    key={i}
                    style={{ fontSize: 14, marginBottom: 6 }}
                  >
                    {description}
                  </Typography>
                );
              })}
            </Box>
          ) : (
            <Typography style={{ fontSize: 14, color: "#888" }}>
              No features listed.
            </Typography>
          )}
        </Box>

        {/* Fixed footer */}
        <Box
          style={{
            flexShrink: 0,
            borderTop: "1px solid #00000014",
            display: "flex",
            justifyContent: "center",
            padding: "16px 30px",
          }}
        >
          <Button
            variant="contained"
            size="small"
            onClick={handleClose}
            style={{
              minWidth: "155px",
              height: "40px",
              fontWeight: "550",
              boxShadow: "none",
              fontSize: "14px",
              background: `var(--color-primary)`,
              color: "white",
            }}
          >
            Close
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SubscriptionViewModal;
